import toast from 'react-hot-toast';
import { UpdateOrganizationInput } from 'src/API';
import { organizationApi } from 'src/api/organizations';
import { AppThunk } from 'src/store';
import $log from 'src/log/log';
import { slice } from 'src/slices/organization';

const updateOrganization =
  (request: UpdateOrganizationInput): AppThunk =>
  async (dispatch) => {
    try {
      const response = await organizationApi.updateOrganization(request);
      toast.success('Organization successfully updated');
    } catch (error) {
      toast.error('Failed to update organization');
    }
  };

const listOrganizations =
  (): AppThunk =>
  async (dispatch): Promise<void> => {
    $log.debug('get_organizations user');
    dispatch(
      slice.actions.setPending({
        attribute: 'listOrganizations',
      }),
    );
    const result = await organizationApi.getOrganizations();
    // console.log('organization result', result)
    if (result.ok) {
      const organizations = result.result;
      dispatch(slice.actions.listOrganizations(organizations));
      dispatch(
        slice.actions.setFulfilled({
          message: 'Successfully fetched organizations',
          attribute: 'listOrganizations',
        }),
      );
      // dispatch(slice.actions.isFetching(false))
    } else {
      toast.error('Error getting organizations');
      dispatch(slice.actions.setRejected({ attribute: 'listOrganizations', message: 'Error getting organizations' }));
    }
  };

export const thunks = {
  updateOrganization,
  listOrganizations,
};
